import { CAT_GLOBAL_SEARCH } from 'App/utils/Collections';

export default {
  category: CAT_GLOBAL_SEARCH,
  filters: [],
  searchBarProp: 'q',
};
